<template>
  <div class="login-dialog--login__content-container--text">
    <h2 class="login-dialog--login__content-container--text__title primary-font">{{ title }}</h2>
    <span class="login-dialog--login__content-container--text__subtitle secondary-font"
      :style="layout == 'portal' ? '' : 'color: #222222'">{{ description }}</span>
    <v-form v-model="validated">
      <v-text-field ref="emailInput" type="email"
        :background-color="layout == 'portal' ? '' : 'var(--v-primary-opacity-12)'" :rules="[rules.required, rules.email]"
        :class="layout == 'portal' ? 'portal-theme' : ''"
        class="login-dialog--login__content-container--text__input login-dialog--login__content-container--text__input--single pt-6" v-model="email" @input="onInput"
        @keydown.enter="submit" validate-on-blur placeholder="E-post" :error-messages="addNewEmailProcess && currentEmail == email ? 'Dette er e-post adressen som er registrert på din bruker. Prøv på nytt.' : error">
      </v-text-field>
    </v-form>
  </div>
</template>

<script>
export default {
  name: "the-email",
  props: {
    title: {
      required: true,
      default: ''
    },
    description: {
      required: true,
      default: ''
    },
    layout: {
      required: false,
      default: 'chain',
      type: String
    },
    error: {
      required: false,
      default: '',
      type: String
    },
    addNewEmailProcess: {
      required: false,
      default: false,
      type: Boolean
    },
    currentEmail: {
      required: false,
      default: null,
      type: String
    }
  },
  data() {
    return {
      email: '',
      rules: {
        required: value => !!value || 'Dette feltet er obligatorisk.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9_]+\.)+[a-zA-Z]{2,}))$/
          const unspportedDomains = ['yourwish.no']
          const illegalDomain = unspportedDomains.includes(value.split('@')[1])
          return pattern.test(value) && !illegalDomain || (illegalDomain ? 'Dette domenet kan ikke brukes.' : 'Ugyldig e-postaddresse.')
        },
      },
      validated: false,
    }
  },
  methods: {
    submit(event) {
      event.preventDefault();
      this.onInput(event?.srcElement?._value)
      this.$emit("verify");
    },
    onInput(value) {
      this.$emit("setValue", value);
    },
    validate() {
      return this.validated
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.emailInput.$refs.input.focus()
      })
    })
  }
}
</script>
<style lang="scss" scoped>
  .portal-theme.theme--light.v-text-field:not(.v-input--has-state) {
    color: #579FA7 !important;
  }
</style>